export default "__VITE_ASSET__xOaxKZ46__"